export default __webpack_public_path__ + "static/media/poster-sdg-6.640f1e5a.png";